import { reactive } from 'vue'

export const store = reactive({
  showTutorial: false,
  lang: 'en'
})
